import 'jquery';
import '../utils/slick.js';

jQuery(function () {
  jQuery('.review-cards.with-slider .review-cards__block').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: "<div class='slick-arrow arrow-left'> </div>",
    nextArrow: "<div class='slick-arrow arrow-right'> </div>",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });
});
